module.exports = __webpack_public_path__ + "static/moon-a2b543c4cd6da8328ac527eaae55837d.png";